import React from 'react'
import {useRouteLoaderData} from '@remix-run/react'
import type {FunctionComponent} from 'react'
import clsx from 'clsx'
import {getDomainConfig} from '~/domains'
import {getTranslation} from '~/localization/translation'
import type {RootLoaderResponse} from '~/types'
import {cloudfrontBaseUrl} from '~/utils/constants'

const CyberMondayInfo: FunctionComponent = () => {
  const {language, domain, locale} = useRouteLoaderData('root') as RootLoaderResponse
  const translations = getTranslation(language)
  const {domainName} = getDomainConfig(domain, locale)

  const isBestReviews = domainName === 'bestreviews'

  const iconUrl = `${cloudfrontBaseUrl}/cyber-monday/discount_icon.png`
  const logoUrl = `${cloudfrontBaseUrl}/cyber-monday/cyber_monday_is_here.png`
  const logoMobileUrl = `${cloudfrontBaseUrl}/cyber-monday/cyber_monday.png`
  const logoMobileShortUrl = `${cloudfrontBaseUrl}/cyber-monday/cyber_monday_mobile.png`

  return (
    <div className={clsx('mx-auto flex flex-row items-center gap-1')}>
      <div
        className={clsx(
          'h-[29px] w-[34px] mobile:h-[24px] mobile:w-[27px] mobile:rotate-[120deg] [&>img]:h-[29px] [&>img]:w-[34px] [&>img]:mobile:h-[24px] [&>img]:mobile:w-[27px]',
          !isBestReviews && 'mobile:hidden',
        )}
      >
        <img src={iconUrl} alt="black friday icon" />
      </div>
      <div className="flex flex-row items-center gap-1 mobile:flex-col mobile:gap-0 [&>div]:mx-auto">
        <div
          className={clsx(
            'mobile:hidden',
            isBestReviews
              ? 'h-[24px] w-[204px] [&>img]:h-[24px] [&>img]:w-[204px]'
              : 'h-[22px] w-[120px] [&>img]:h-[22px] [&>img]:w-[120px]',
          )}
        >
          <img src={isBestReviews ? logoUrl : logoMobileUrl} alt="black friday logo" />
        </div>

        <div
          className={clsx(
            isBestReviews
              ? 'hidden mobile:block mobile:h-[16px] mobile:w-[82px] [&>img]:mobile:h-[16px] [&>img]:mobile:w-[82px]'
              : 'hidden mobile:block mobile:h-[32px] mobile:w-[52px] [&>img]:mobile:h-[32px] [&>img]:mobile:w-[52px]',
          )}
        >
          <img src={isBestReviews ? logoMobileUrl : logoMobileShortUrl} alt="black friday logo" />
        </div>

        <span className={clsx('text-sm font-medium', !isBestReviews ? 'hidden' : 'hidden mobile:-mt-1 mobile:block')}>
          {translations.CyberMonday.isHere}
        </span>
      </div>
    </div>
  )
}

export default CyberMondayInfo
